import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";
import logoImage from "@/assets/logo-epp-new.webp";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-card border-t border-border">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
          {/* Logo et description */}
          <div className="col-span-1">
            <img src={logoImage} alt="EPP - Espaces Paysages Propreté" className="h-16 w-auto mb-4" width="143" height="80" loading="lazy" />
            <p className="text-sm text-muted-foreground">
              Expert en nettoyage professionnel depuis 2015. Services de qualité pour entreprises et particuliers.
            </p>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-semibold mb-4">Nos Services</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/services/vitrerie" className="text-muted-foreground hover:text-primary transition-colors">Nettoyage Vitrerie</Link></li>
              <li><Link to="/services/facades" className="text-muted-foreground hover:text-primary transition-colors">Nettoyage Façades</Link></li>
              <li><Link to="/services/bureaux" className="text-muted-foreground hover:text-primary transition-colors">Entretien Bureaux</Link></li>
              <li><Link to="/services/espaces-verts" className="text-muted-foreground hover:text-primary transition-colors">Espaces Verts</Link></li>
              <li><Link to="/services/boutiques" className="text-muted-foreground hover:text-primary transition-colors">Boutiques & Commerces</Link></li>
              <li><Link to="/services/industriel" className="text-muted-foreground hover:text-primary transition-colors">Nettoyage Industriel</Link></li>
            </ul>
          </div>

          {/* Secteurs */}
          <div>
            <h3 className="font-semibold mb-4">Secteurs</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/secteurs/commerces" className="text-muted-foreground hover:text-primary transition-colors">Commerces</Link></li>
              <li><Link to="/secteurs/industries" className="text-muted-foreground hover:text-primary transition-colors">Industries</Link></li>
              <li><Link to="/secteurs/collectivites" className="text-muted-foreground hover:text-primary transition-colors">Collectivités</Link></li>
            </ul>
            <h3 className="font-semibold mb-4 mt-6">Zones d'Intervention</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/zones/nantes" className="text-muted-foreground hover:text-primary transition-colors">Nantes</Link></li>
              <li><Link to="/zones/saint-herblain" className="text-muted-foreground hover:text-primary transition-colors">Saint-Herblain</Link></li>
              <li><Link to="/zones/reze" className="text-muted-foreground hover:text-primary transition-colors">Rezé</Link></li>
              <li><Link to="/zones/orvault" className="text-muted-foreground hover:text-primary transition-colors">Orvault</Link></li>
              <li><Link to="/zones/vertou" className="text-muted-foreground hover:text-primary transition-colors">Vertou</Link></li>
              <li><Link to="/zones/carquefou" className="text-muted-foreground hover:text-primary transition-colors">Carquefou</Link></li>
              <li><Link to="/zones/bouguenais" className="text-muted-foreground hover:text-primary transition-colors">Bouguenais</Link></li>
            </ul>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="font-semibold mb-4">Navigation</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="text-muted-foreground hover:text-primary transition-colors">Accueil</Link></li>
              <li><Link to="/services" className="text-muted-foreground hover:text-primary transition-colors">Services</Link></li>
              <li><Link to="/blog" className="text-muted-foreground hover:text-primary transition-colors">Blog & Guides</Link></li>
              <li><Link to="/a-propos" className="text-muted-foreground hover:text-primary transition-colors">À propos</Link></li>
              <li><Link to="/contact" className="text-muted-foreground hover:text-primary transition-colors">Contact</Link></li>
              <li><Link to="/devis" className="text-muted-foreground hover:text-primary transition-colors">Devis Gratuit</Link></li>
              <li><Link to="/cgv" className="text-muted-foreground hover:text-primary transition-colors">CGV</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold mb-4">Contact</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <MapPin className="h-4 w-4 text-primary mt-0.5 flex-shrink-0" />
                <span className="text-muted-foreground">2 rue Robert-le-Ricolais<br />44300 Nantes</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-primary flex-shrink-0" />
                <a href="tel:0769638777" className="text-muted-foreground hover:text-primary transition-colors">07 69 63 87 77</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border mt-8 pt-8 text-center text-sm text-muted-foreground">
          <p>&copy; {currentYear} EPP Espaces Paysages & Propreté. Tous droits réservés. | SARL au capital de 4000€ | SIREN : 813 739 778</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
